var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87695 0.652344V4.65234C9.87695 4.91756 9.98231 5.17191 10.1698 5.35945C10.3574 5.54699 10.6117 5.65234 10.877 5.65234H14.877M9.87695 0.652344H2.87695C2.34652 0.652344 1.83781 0.863057 1.46274 1.23813C1.08767 1.6132 0.876953 2.12191 0.876953 2.65234V16.6523C0.876953 17.1828 1.08767 17.6915 1.46274 18.0666C1.83781 18.4416 2.34652 18.6523 2.87695 18.6523H12.877C13.4074 18.6523 13.9161 18.4416 14.2912 18.0666C14.6662 17.6915 14.877 17.1828 14.877 16.6523V5.65234M9.87695 0.652344L14.877 5.65234M4.87695 6.65234H5.87695M4.87695 10.6523H10.877M4.87695 14.6523H10.877",
    stroke: "#2D1C5B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.47f90a32f7d50a01c2ef65ebd3a2019d.svg";
export { ForwardRef as ReactComponent };